export default __webpack_public_path__ + "static/media/SurveyorText-LightItalic.18e595c7.woff";